(function($, document, window) {    
    function jumbotron(jumbotronElement) {
        var $jt = $(jumbotronElement);

        var slides = $jt.find('.om-jumbotron-slide');
        if(slides.length < 2) {
            return;
        }

        var autoplaySpeed = $jt.attr('data-speed');
        var autoplay = false;
  
        if (autoplaySpeed !== undefined && autoplaySpeed > 0) {
          autoplay = true;
        }

        var adaptiveheight = !$jt.closest('.om-jumbotron-block-container').hasClass('om-jumbotron-limitheight');
  
        $jt.slick({
          dots: true,
          mobileFirst: true,
          adaptiveHeight: adaptiveheight,
          autoplay: autoplay,
          autoplaySpeed: autoplaySpeed
        });
    }


    $(function () {
        $('.js-jumbotron').each(function(idx, element) {            
            new jumbotron(element);
        });
    });

} (jQuery, document, window));